import React, { Component } from 'react';
import { Modal, Row, Col, Input, message } from 'antd';
import Text from '../../basicElement/Text';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';

const TextArea = Input.TextArea;

class AcLog extends Component {
    state = {
        data: {},
        loading: false,
        visible: false,
        remark: ''
    }

    show = (investigationId, opStatus) => {
        this.setState({
            investigationId,
            opStatus,
            visible: true
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (e) => {
        this.setState({
            remark: e.target.value
        });
    }

    confirm = () => {
        const { investigationId, remark, opStatus } = this.state;
        if (!remark && remark !== 0) {
            return message.warning('备注不能为空');
        }

        const { invId } = sessionStorage;


        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: `${API_URL.sumtotal.setInvestigationAc}`,
            data: {
                status: opStatus,
                remark,
                investigationId: investigationId > 0 ? investigationId : invId,
            },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.setState({
                        visible: false,
                        loading: false,
                        remark: "",
                    }, () => {
                        this.props.nowAcStatus();
                        this.props.loadData();
                    });
                });
            },
            errorResult: () => {
                this.setState({ loading: false,visible:false, remark:'' });
            }
        };
        $.sendRequest(options);
    }




    render() {
        const { visible, loading, opStatus, remark } = this.state;


        const val = `请填写此次${opStatus == 'CLOSE' ? '关闭' : '开启'}自动调整AC开关的备注:`;
        return (
            <Modal
                title={opStatus == 'CLOSE' ? '关闭自动调整AC开关备注' : '开启自动调整AC开关备注'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                confirmLoading={loading}
                maskClosable={false}
                width="500px"
                bodyStyle={{ height: 200 }}
            >
                <Col>
                    <Row span={2}>{val}</Row>
                    <Row span={4}>
                        <TextArea placeholder='请填写项目备注' value={remark} rows={4} onChange={this.handleChange} />
                    </Row>
                </Col>
            </Modal>
        );
    }
}

export default AcLog;


// WEBPACK FOOTER //
// ./src/components/sumTotal/projectPercent/AcLog.js